<template>
	<div class="body info" v-if="editForm.id">
		<el-steps :active="step" align-center class="steps">
			<el-step title="基本信息"></el-step>
			<el-step title="植物学性状"></el-step>
			<el-step title="果形"></el-step>
			<el-step title="果皮"></el-step>
			<el-step title="果肉"></el-step>
			<el-step title="品质"></el-step>
		</el-steps>
		<el-form ref="editForm" :model="editForm" class="form_h" size="mini" label-position="left" label-width="auto">
			<div  v-if="step==0">
				<el-row class="" :gutter="20">
					<el-col :span="8">
						<el-form-item label="片区/地块：" prop="area">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.area_name}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="种质名称：" prop="zhongzhimingcheng">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.zhongzhimingcheng}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="种植圃：" prop="zhongzhipu">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.zhongzhipu}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="外文名：" prop="waiwenming">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.waiwenming}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="亲本：" prop="qinben">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.qinben}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="原产地：" prop="yuanchandi">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.yuanchandi}}</div></div>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="" :gutter="20">
					<el-col :span="8">
						<el-form-item label="S基因型：" prop="Sjiyinxing">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.Sjiyinxing}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="调查人：" prop="diaocharen">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.diaocharen}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="来源：" prop="laiyuan_value">
							<div class="el-input--mini"><div class="el-input__inner">{{LAIYUAN[editForm.laiyuan_value]}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8" v-if="editForm.laiyuan_value=='-1'">
						<el-form-item label="其他来源：" prop="laiyuan_text">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.laiyuan_text}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="调查时间：" prop="diaochashijian">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.diaochashijian}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="调查地点：" prop="diaochadidian">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.diaochadidian}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="用途：" prop="yongtu_value">
							<div class="el-input--mini"><div class="el-input__inner">{{PURPOSE[editForm.yongtu_value]}}</div></div>
						</el-form-item>
					</el-col>
				</el-row>
			</div>
			<div v-if="step==1">
				<el-row class="" :gutter="20">
					<el-col :span="8" class="yizu">
						<el-form-item label="树姿：" prop="shuzi_value">
							<div class="el-input--mini"><div class="el-input__inner">{{TREE_VIGOR[editForm.shuzi_value]}}</div></div>
						</el-form-item>
						<el-card class="box-card">
							<el-form-item label="树势：" prop="shushi_value">
								<div class="el-input--mini"><div class="el-input__inner">{{TREE_POSTURE[editForm.shushi_value]}}</div></div>
							</el-form-item>
							<el-form-item label="树势图片：" prop="shushi_image" v-if="editForm.shushi_image.show.length>0">
								<div class="el-upload el-upload--text"  v-for="item in editForm.shushi_image.show">
									<img :src="item" class="avatar">
								</div>
							</el-form-item>
						</el-card>
					</el-col>
					<el-col :span="8" class="yizu">
						<el-card class="box-card">
							<el-form-item label="一年生枝条颜色：" prop="yinianshengzhitiaoyanse_value">
								<div class="el-input--mini"><div class="el-input__inner">{{COLOUR_1[editForm.yinianshengzhitiaoyanse_value]}}</div></div>
							</el-form-item>
							<el-form-item label="一年生枝条颜色(其他)：" prop="yinianshengzhitiaoyanse_text" v-if="editForm.yinianshengzhitiaoyanse_value=='-1'">
								<div class="el-input--mini"><div class="el-input__inner">{{editForm.yinianshengzhitiaoyanse_text}}</div></div>
							</el-form-item>
							<el-form-item label="一年生枝条颜色图片：" prop="shushi_image" v-if="editForm.yinianshengzhitiaoyanse_image.show.length>0">
								<div class="el-upload el-upload--text"  v-for="item in editForm.yinianshengzhitiaoyanse_image.show">
									<img :src="item" class="avatar">
								</div>
							</el-form-item>
						</el-card>
					</el-col>
					<el-col :span="8" class="yizu">
						<el-card class="box-card">
							<el-form-item label="新梢颜色：" prop="xinshaoyanse_value">
								<div class="el-input--mini"><div class="el-input__inner">{{COLOUR_2[editForm.xinshaoyanse_value]}}</div></div>
							</el-form-item>
							<el-form-item label="新梢颜色(其他)：" prop="xinshaoyanse_text" v-if="editForm.xinshaoyanse_value=='-1'">
								<div class="el-input--mini"><div class="el-input__inner">{{editForm.xinshaoyanse_text}}</div></div>
							</el-form-item>
							<el-form-item label="新梢颜色图片：" prop="shushi_image" v-if="editForm.xinshaoyanse_image.show.length>0">
								<div class="el-upload el-upload--text"  v-for="item in editForm.xinshaoyanse_image.show">
									<img :src="item" class="avatar">
								</div>
							</el-form-item>
						</el-card>
					</el-col>
				</el-row>
				<el-row class="" :gutter="20">
					<el-col :span="8" class="yizu">
						<el-card class="box-card">
							<el-form-item label="春嫩叶色：" prop="chunnenyese_value">
								<div class="el-input--mini"><div class="el-input__inner">{{COLOUR_3[editForm.chunnenyese_value]}}</div></div>
							</el-form-item>
							<el-form-item label="春嫩叶色(其他)：" prop="chunnenyese_text" v-if="editForm.chunnenyese_value=='-1'">
								<div class="el-input--mini"><div class="el-input__inner">{{editForm.chunnenyese_text}}</div></div>
							</el-form-item>
							<el-form-item label="春嫩叶色图片：" prop="chunnenyese_image" v-if="editForm.chunnenyese_image.show.length>0">
								<div class="el-upload el-upload--text"  v-for="item in editForm.chunnenyese_image.show">
									<img :src="item" class="avatar">
								</div>
							</el-form-item>
						</el-card>
					</el-col>
					<el-col :span="8" class="yizu">
						<el-card class="box-card">
							<el-form-item label="叶柄颜色：" prop="yebingyanse_value">
								<div class="el-input--mini"><div class="el-input__inner">{{COLOUR_4[editForm.yebingyanse_value]}}</div></div>
							</el-form-item>
							<el-form-item label="叶柄颜色图片：" prop="yebingyanse_image" v-if="editForm.yebingyanse_image.show.length>0">
								<div class="el-upload el-upload--text"  v-for="item in editForm.yebingyanse_image.show">
									<img :src="item" class="avatar">
								</div>
							</el-form-item>
						</el-card>
					</el-col>
					<el-col :span="8" class="yizu">
						<el-card class="box-card">
							<el-form-item label="叶片：" prop="yepianyanse_value">
								<div class="el-input--mini"><div class="el-input__inner">{{COLOUR_5[editForm.yepianyanse_value]}}</div></div>
							</el-form-item>
							<el-form-item label="叶片(其他)：" prop="yepianyanse_text" v-if="editForm.yepianyanse_value=='-1'">
								<div class="el-input--mini"><div class="el-input__inner">{{editForm.yepianyanse_text}}</div></div>
							</el-form-item>
							<el-form-item label="叶片图片：" prop="yepianyanse_image" v-if="editForm.yepianyanse_image.show.length>0">
								<div class="el-upload el-upload--text"  v-for="item in editForm.yepianyanse_image.show">
									<img :src="item" class="avatar">
								</div>
							</el-form-item>
						</el-card>
					</el-col>
				</el-row>
				<el-row class="" :gutter="20">
					<el-col :span="8" class="yizu">
						<el-card class="box-card">
							<el-form-item label="蜜腺：" prop="yexianxingzhuang_value">
								<div class="el-input--mini"><div class="el-input__inner">{{NECTARY[editForm.yexianxingzhuang_value]}}</div></div>
							</el-form-item>
							<el-form-item label="蜜腺数量：" prop="mixianshuliang">
								<div class="el-input--mini"><div class="el-input__inner">{{editForm.mixianshuliang}}</div></div>
							</el-form-item>
							<!-- <el-form-item label="叶腺性状图片：" prop="yexianxingzhuang_image" v-if="editForm.yexianxingzhuang_image.show.length>0">
								<div class="el-upload el-upload--text"  v-for="item in editForm.yexianxingzhuang_image.show">
									<img :src="item" class="avatar">
								</div>
							</el-form-item> -->
						</el-card>
					</el-col>
					<el-col :span="8" class="yizu">
						<el-card class="box-card">
							<el-form-item label="花蕾颜色：" prop="hualeiyanse_value">
								<div class="el-input--mini"><div class="el-input__inner">{{COLOUR_8[editForm.hualeiyanse_value]}}</div></div>
							</el-form-item>
							<el-form-item label="花蕾颜色图片：" prop="hualeiyanse_image" v-if="editForm.hualeiyanse_image.show.length>0">
								<div class="el-upload el-upload--text"  v-for="item in editForm.hualeiyanse_image.show">
									<img :src="item" class="avatar">
								</div>
							</el-form-item>
						</el-card>
					</el-col>
					<el-col :span="8" class="yizu">
						<el-card class="box-card">
							<el-form-item label="花径(cm)：" prop="huajing">
								<div class="el-input--mini"><div class="el-input__inner">{{editForm.huajing}}</div></div>
							</el-form-item>
							<el-form-item label="花径图片：" prop="huajing_image" v-if="editForm.huajing_image.show.length>0">
								<div class="el-upload el-upload--text"  v-for="item in editForm.huajing_image.show">
									<img :src="item" class="avatar">
								</div>
							</el-form-item>
						</el-card>
					</el-col>
				</el-row>
				<el-row class="" :gutter="20">
					<el-col :span="8">
						<el-form-item label="叶片平展程度：" prop="yepianpingzhanchengdu_value">
							<div class="el-input--mini"><div class="el-input__inner">{{FLATTENING_DEGREE[editForm.yepianpingzhanchengdu_value]}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="叶腺颜色：" prop="yexianyanse_value">
							<div class="el-input--mini"><div class="el-input__inner">{{COLOUR_7[editForm.yexianyanse_value]}}</div></div>
						</el-form-item>
					</el-col>
					<!-- <el-col :span="8">
						<el-form-item label="叶腺数量(个)：" prop="yexianshuliang">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.yexianshuliang}}</div></div>
						</el-form-item>
					</el-col> -->
					<el-col :span="8">
						<el-form-item label="花朵数量(朵)：" prop="huaduoshu">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.huaduoshu}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="萌芽期：" prop="mengyaqi_value">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.mengyaqi_value}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="始花期：" prop="shihuaqi_value">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.shihuaqi_value}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="末花期：" prop="mohuaqi_value">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.mohuaqi_value}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="果实着色期：" prop="guoshizhuoseqi_value">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.guoshizhuoseqi_value}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="果实成熟期：" prop="guoshichengshuqi_value">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.guoshichengshuqi_value}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="果实生育期：" prop="guoshishengyuqian_value">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.guoshishengyuqian_value}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="落叶期：" prop="luoyeqi_value">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.luoyeqi_value}}</div></div>
						</el-form-item>
					</el-col>
				</el-row>
			</div>
			<div v-if="step==2">
				<el-row class="" :gutter="20">
					<el-col :span="8" class="yizu">
						<el-card class="box-card">
							<el-form-item label="果形：" prop="guoxing_value">
								<div class="el-input--mini"><div class="el-input__inner">{{FRUIT_SHAPE[editForm.guoxing_value]}}</div></div>
							</el-form-item>
							<el-form-item label="果形(其他)：" prop="guoxing_text" v-if="editForm.guoxing_value=='-1'">
								<div class="el-input--mini"><div class="el-input__inner">{{editForm.guoxing_text}}</div></div>
							</el-form-item>
							<el-form-item label="果形图片：" prop="guoxing_image">
								<div class="el-upload el-upload--text"  v-for="item in editForm.guoxing_image.show">
									<img :src="item" class="avatar">
								</div>
							</el-form-item>
						</el-card>
					</el-col>
					<el-col :span="8">
						<el-form-item label="平均果重(g)：" prop="pingjunguozhong">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.pingjunguozhong}}</div></div>
						</el-form-item>
						<el-form-item label="最大果重(g)：" prop="zuidaguozhong">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.zuidaguozhong}}</div></div>
						</el-form-item>
						<el-form-item label="梗洼(广)：" prop="gengwa_value">
							<div class="el-input--mini"><div class="el-input__inner">{{STEM_DEPRESSION[editForm.gengwa_value]}}</div></div>
						</el-form-item>
						<el-form-item label="梗洼(深)：" prop="gengwa2_value">
							<div class="el-input--mini"><div class="el-input__inner">{{STEM_DEPRESSION1[editForm.gengwa2_value]}}</div></div>
						</el-form-item>
						<el-form-item label="梗洼(陡)：" prop="gengwa3_value">
							<div class="el-input--mini"><div class="el-input__inner">{{STEM_DEPRESSION2[editForm.gengwa3_value]}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="整齐度：" prop="zhengqidu_value">
							<div class="el-input--mini"><div class="el-input__inner">{{UNIFORMITY[editForm.zhengqidu_value]}}</div></div>
						</el-form-item>
						<el-form-item label="缝合线：" prop="fenghexian_value">
							<div class="el-input--mini"><div class="el-input__inner">{{SUTURE[editForm.fenghexian_value]}}</div></div>
						</el-form-item>
						<el-form-item label="缝合线明显：" prop="fenghexian2_value">
							<div class="el-input--mini"><div class="el-input__inner">{{SUTURE1[editForm.fenghexian2_value]}}</div></div>
						</el-form-item>
						<el-form-item label="果顶：" prop="guoding_value">
							<div class="el-input--mini"><div class="el-input__inner">{{FRUIT_APEX[editForm.guoding_value]}}</div></div>
						</el-form-item>
					</el-col>
				</el-row>
			</div>
			<div v-if="step==3">
				<el-row class="" :gutter="20">
					<el-col :span="8">
						<el-form-item label="底色：" prop="dise_value">
							<div class="el-input--mini"><div class="el-input__inner">{{BACKGROUND_COLOR[editForm.dise_value]}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="盖色：" prop="gaise_value">
							<div class="el-input--mini"><div class="el-input__inner">{{COLOUR_6[editForm.gaise_value]}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="着色程度：" prop="zhuosechengdu_value">
							<div class="el-input--mini"><div class="el-input__inner">{{COLORING_DEGREE[editForm.zhuosechengdu_value]}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="质地(厚)：" prop="zhidi_value">
							<div class="el-input--mini"><div class="el-input__inner">{{TEXTURE[editForm.zhidi_value]}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="质地(韧)：" prop="zhidi2_value">
							<div class="el-input--mini"><div class="el-input__inner">{{TEXTURE1[editForm.zhidi2_value]}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="果形及外观色泽：" prop="guoxingjiwaiguanseze_value">
							<div class="el-input--mini"><div class="el-input__inner">{{APPEARANCE_COLOR[editForm.guoxingjiwaiguanseze_value]}}</div></div>
						</el-form-item>
					</el-col>
				</el-row>
			</div>
			<div v-if="step==4">
				<el-row class="" :gutter="20">
					<el-col :span="8">
						<el-form-item label="色泽：" prop="seze_value">
							<div class="el-input--mini"><div class="el-input__inner">{{COLOR_AND_LUSTRE[editForm.seze_value]}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="肉质：" prop="rouzhi_value">
							<div class="el-input--mini"><div class="el-input__inner">{{MEAT_QUALITY[editForm.rouzhi_value]}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="果肉厚度(cm)：" prop="guorouhoudu">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.guorouhoudu}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="硬度：" prop="yingdu">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.yingdu}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="汁液：" prop="zhiye_value">
							<div class="el-input--mini"><div class="el-input__inner">{{JUICE[editForm.zhiye_value]}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="纤维(少)：" prop="xianwei_value">
							<div class="el-input--mini"><div class="el-input__inner">{{FIBRE[editForm.xianwei_value]}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="纤维(细)：" prop="xianwei_value">
							<div class="el-input--mini"><div class="el-input__inner">{{FIBRE1[editForm.xianwei2_value]}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="苦涩味：" prop="kusewei_value">
							<div class="el-input--mini"><div class="el-input__inner">{{BITTERNESS[editForm.kusewei_value]}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="香气：" prop="xiangqi_value">
							<div class="el-input--mini"><div class="el-input__inner">{{AROMA[editForm.xiangqi_value]}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="果核粘离：" prop="guohenianli_value">
							<div class="el-input--mini"><div class="el-input__inner">{{STONE[editForm.guohenianli_value]}}</div></div>
						</el-form-item>
					</el-col>
				</el-row>
			</div>
			<div v-if="step==5">
				<el-row class="" :gutter="20">
					<el-col :span="8">
						<el-form-item label="风味：" prop="fengwei_value">
							<div class="el-input--mini"><div class="el-input__inner">{{FLAVOR[editForm.fengwei_value]}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="可溶性固形物含量(%)：" prop="kerongxingguxingwuhanliang">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.kerongxingguxingwuhanliang}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="可溶性糖含量(%)：" prop="kerongxingtanghanliang">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.kerongxingtanghanliang}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="总酸含量(%)：" prop="kerongxingsuanhanliang">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.kerongxingsuanhanliang}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="Vc含量：" prop="Vchanliang">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.Vchanliang}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="可滴定酸含量(%)：" prop="kedidingsuanhanliang">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.kedidingsuanhanliang}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="微量元素：" prop="weiliangyuansu">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.weiliangyuansu}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="可食率(%)：" prop="keshilv">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.keshilv}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="鲜食品质：" prop="xianshipinzhi_value">
							<div class="el-input--mini"><div class="el-input__inner">{{QUALITY[editForm.xianshipinzhi_value]}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="耐贮性：" prop="zhucunxing_value">
							<div class="el-input--mini"><div class="el-input__inner">{{STORABILITY[editForm.zhucunxing_value]}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="裂果：" prop="lieguo">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.lieguo}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="优点：" prop="youdian">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.youdian}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="缺点：" prop="quedian">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.quedian}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="病害：" prop="binghai">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.binghai}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="鉴定意见：" prop="jiandingyijian_value">
							<div class="el-input--mini"><div class="el-input__inner">{{OPINION[editForm.jiandingyijian_value]}}</div></div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="备注：" prop="beizhu">
							<div class="el-input--mini"><div class="el-input__inner">{{editForm.beizhu}}</div></div>
						</el-form-item>
					</el-col>
				</el-row>
			</div>
		</el-form>
		<div class="anjian">
			<el-button type="primary" @click.native="step=step-1" v-if="step>0">上一步</el-button>
			<el-button type="primary" @click.native="emailEdit">编辑</el-button>
			<el-button type="primary" @click.native="step=step+1" v-if="step<5">下一步</el-button>
		</div>

      <data-data :editFormVisible="editFormVisible" :editForm_data="editForm_data" @editFormVisible_f="editFormVisible_f" :step_is="step_is" :step="step"></data-data>
	</div>
</template>
<script>
import global   from  '../../global.vue'
import DataData from '../../components/datadata.vue'
export default {
	components:{
		DataData
	},
	data() {
		return {
			editFormVisible: false,
			id:'',
			http:global.http,
			step: 0,
			step_is:true,
			editForm_data:{},
			editForm: {
				area_arr:[],
				area: '',
				area_block: '',
				zhongzhimingcheng: '',
				zhongzhi_image:{
					show:[],
					save:[],
				},
				waiwenming: '',
				qinben: '',
				yuanchandi: '',
				qinben: '',
				Sjiyinxing: '',
				laiyuan_value: '',
				laiyuan_text: '',
				diaochashijian: '',
				diaocharen: '',
				diaochadidian: '',
				yongtu_value: '',

				shushi_value: '',
				shushi_image:{
					show:[],
					save:[],
				},
				shuzi_value: '',
				shuzi_image: {
					show:[],
					save:[],
				},


				yinianshengzhitiaoyanse_value: '',
				yinianshengzhitiaoyanse_text: '',
				yinianshengzhitiaoyanse_image: {
					show:[],
					save:[],
				},
				xinshaoyanse_value: '',
				xisnhaoyanse_text: '',
				xinshaoyanse_image:{
					show:[],
					save:[],
				},
				chunnenyese_value: '',
				chunnenyese_text: '',
				chunnenyese_image:{
					show:[],
					save:[],
				},
				yebingyanse_value: '',
				yebingyanse_image: {
					show:[],
					save:[],
				},
				yepianyanse_value: '',
				yepianyanse_text: '',
				yepianyanse_image: {
					show:[],
					save:[],
				},
				yepianpingzhanchengdu_value: '',
				yexianxingzhuang_value: '',
				yexianxingzhuang_image: {
					show:[],
					save:[],
				},
				yexianyanse_value: '',
				mixianshuliang: '',
				mengyaqi_value: '',
				shihuaqi_value: '',
				mohuaqi_value: '',
				hualeiyanse_value: '',
				huaduoshu: '',
				huajing: '',
				huajing_image: '',
				guoshizhuoseqi_value: '',
				guoshichengshuqi_value: '',
				guoshishengyuqian_value: '',
				luoyeqi_value: '',

				pingjunguozhong: '',
				zuidaguozhong: '',
				guoxing_value: '',
				guoxing_text: '',
				guoxing_image: '',
				guoding_value: '',
				zhengqidu_value: '',
				fenghexian_value: '',
				gengwa_value: '',

				dise_value: '',
				gaise_value: '',
				zhuosechengdu_value: '',
				zhidi_value: '',
				guoxingjiwaiguanseze_value: '',

				seze_value: '',
				rouzhi_value: '',
				guorouhoudu: '',
				zhiye_value: '',
				xianwei_value: '',
				kusewei_value: '',
				xiangqi_value: '',
				guohenianli_value: '',

				fengwei_value: '',
				kerongxingguxingwuhanliang: '',
				kerongxingtanghanliang: '',
				kerongxingsuanhanliang: '',
				Vchanliang: '',
				kedidingsuanhanliang: '',
				weiliangyuansu: '',
				keshilv: '',
				xianshipinzhi_value: '',
				zhucunxing_value: '',
				lieguo: '',
				youdian: '',
				quedian: '',
				binghai: '',
				jiandingyijian_value: '',
				beizhu: '',
				info_id: '',
			},
			area_data: [],
			area_block_data: [],
			LAIYUAN: [],
			PURPOSE: [],
			TREE_VIGOR: [],
			TREE_POSTURE: [],
			COLOUR_1: [],
			COLOUR_2: [],
			COLOUR_3: [],
			COLOUR_4: [],
			COLOUR_5: [],
			COLOUR_6: [],
			COLOUR_7: [],
			COLOUR_8: [],
			FLATTENING_DEGREE: [],
			LEAF_GLAND_CHARACTERS: [],
			FRUIT_SHAPE: [],
			FRUIT_APEX: [],
			UNIFORMITY: [],
			SUTURE: [],
			SUTURE1: [],
			STEM_DEPRESSION: [],
			STEM_DEPRESSION1: [],
			STEM_DEPRESSION2: [],
			BACKGROUND_COLOR: [],
			COLORING_DEGREE: [],
			TEXTURE: [],
			TEXTURE1: [],
			APPEARANCE_COLOR: [],
			COLOR_AND_LUSTRE: [],
			MEAT_QUALITY: [],
			JUICE: [],
			FIBRE: [],
			FIBRE1: [],
			BITTERNESS: [],
			AROMA: [],
			STONE: [],
			FLAVOR: [],
			QUALITY: [],
			STORABILITY: [],
			OPINION: [],
			NECTARY: [],

			

		}
	},
	// 初始事件
	mounted: function (e) {
		this.id=this.$route.query.id;
		this.config();
	},
	// 事件
	methods: {
		config(){
			var this_ = this;
			var url = "getDictionaryValue";
			var datas = {
				code: 'LAIYUAN,PURPOSE,TREE_VIGOR,TREE_POSTURE,COLOUR_1,FLATTENING_DEGREE,LEAF_GLAND_CHARACTERS,FRUIT_SHAPE,FRUIT_APEX,UNIFORMITY,SUTURE,SUTURE1,STEM_DEPRESSION,STEM_DEPRESSION1,STEM_DEPRESSION2,BACKGROUND_COLOR,COLOUR_2,COLOUR_3,COLOUR_4,COLOUR_5,COLOUR_6,COLOUR_7,COLOUR_8,COLORING_DEGREE,TEXTURE,TEXTURE1,APPEARANCE_COLOR,COLOR_AND_LUSTRE,MEAT_QUALITY,JUICE,FIBRE,FIBRE1,BITTERNESS,AROMA,STONE,FLAVOR,QUALITY,STORABILITY,OPINION,NECTARY',
			}
			this_.$post(url, datas).then((res) => {
				this_.LAIYUAN = res.LAIYUAN;
				this_.PURPOSE = res.PURPOSE;
				this_.TREE_VIGOR = res.TREE_VIGOR;
				this_.TREE_POSTURE = res.TREE_POSTURE;
				this_.COLOUR_1 = res.COLOUR_1;
				this_.COLOUR_2 = res.COLOUR_2;
				this_.COLOUR_3 = res.COLOUR_3;
				this_.COLOUR_4 = res.COLOUR_4;
				this_.COLOUR_5 = res.COLOUR_5;
				this_.COLOUR_6 = res.COLOUR_6;
				this_.COLOUR_7 = res.COLOUR_7;
				this_.COLOUR_8 = res.COLOUR_8;
				this_.FLATTENING_DEGREE = res.FLATTENING_DEGREE;
				this_.LEAF_GLAND_CHARACTERS = res.LEAF_GLAND_CHARACTERS;
				this_.FRUIT_SHAPE = res.FRUIT_SHAPE;
				this_.FRUIT_APEX = res.FRUIT_APEX;
				this_.UNIFORMITY = res.UNIFORMITY;
				this_.SUTURE = res.SUTURE;
				this_.SUTURE1 = res.SUTURE1;
				this_.STEM_DEPRESSION = res.STEM_DEPRESSION;
				this_.STEM_DEPRESSION1 = res.STEM_DEPRESSION1;
				this_.STEM_DEPRESSION2 = res.STEM_DEPRESSION2;
				this_.BACKGROUND_COLOR = res.BACKGROUND_COLOR;
				this_.COLORING_DEGREE = res.COLORING_DEGREE;
				this_.TEXTURE = res.TEXTURE;
				this_.TEXTURE1 = res.TEXTURE1;
				this_.APPEARANCE_COLOR = res.APPEARANCE_COLOR;
				this_.COLOR_AND_LUSTRE = res.COLOR_AND_LUSTRE;
				this_.MEAT_QUALITY = res.MEAT_QUALITY;
				this_.JUICE = res.JUICE;
				this_.FIBRE = res.FIBRE;
				this_.FIBRE1 = res.FIBRE1;
				this_.BITTERNESS = res.BITTERNESS;
				this_.AROMA = res.AROMA;
				this_.STONE = res.STONE;
				this_.FLAVOR = res.FLAVOR;
				this_.QUALITY = res.QUALITY;
				this_.STORABILITY = res.STORABILITY;
				this_.OPINION = res.OPINION;
				this_.NECTARY = res.NECTARY;
			})
			var url = "areaOption";
			this_.$post(url, {}).then((res) => {
				this_.area_data = res;
				this_.init();
			})
		},
		// 初始化
		init() {
			var this_ = this;
			var url = "infoDetail";
			var datas={
				id:this_.id,
			}
			this_.$post(url, datas).then((res) => {
				this_.editForm= res;
			})
		},
		// 编辑
		emailEdit(e) {
			this.step_is=true;
			this.editForm_data=this.editForm;
			this.editFormVisible = true;
		},
		editFormVisible_f(){
			this.editFormVisible = false;
			this.init();
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		}
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.body {
	padding: 20px;
	background-color: #fff;
}
.body .steps {
	margin-bottom: 20px;
}
.filter-panel {
	display: inline-block;
	width: 80%;
	vertical-align: top;
}
.page-pagination {
	padding: 20px 10px;
}
.filter-inline-panel {
	margin-bottom: 10px;
}
.anjian{
	text-align: center;
}
</style>
<style type="text/css">
.info .avatar-uploader{
	display: inline-block;
	vertical-align: top;
	/* margin-right: 10px; */
	/* margin-bottom: 10px; */
}
.info .el-upload {
	margin-right: 10px;
	margin-bottom: 10px;
}
.info .avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}
.info .avatar-uploader .el-upload:hover {
	border-color: #409EFF;
}
.info .avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 80px;
	height: 80px;
	line-height: 80px;
	text-align: center;
}
.info .avatar {
	width: 80px;
	height: 80px;
	display: block;
}
.info .el-input--mini .el-input__inner{
	/* line-height: 26px; */
	display: block;
}
.info .form_h{
	min-height: 440px;
}
.yizu{
	/* box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2); */
	/* border: solid 1px rgba(0, 0, 0, 0.4) */
}
</style>


// WEBPACK FOOTER //
// src/views/list/info.vue